import React from "react";
import { Spinner } from "reactstrap";

const SmBtn = ({
  Title,
  BackgroundColor,
  ColorText,
  BorderColor,
  borderRadius,
  handleOnclick,
  pending,
}) => {
  return (
    <buton
      type="button"
      className="btn"
      style={{
        fontWeight: "600",
        color: ColorText,
        borderColor: BorderColor,
        borderWidth: "2px",
        borderStyle: "solid",
        borderRadius: borderRadius,
        backgroundColor: BackgroundColor,
      }}
      onClick={handleOnclick}
    >
      <div className="d-flex justify-content-center align-items-center">
        {!pending ? <span style={{ fontSize: 11 }}>{Title}</span> : null}
        {!pending ? null : (
          <span>
            <Spinner as="span" animation="border" size="sm" /> Loading
          </span>
        )}
      </div>
    </buton>
  );
};

export default SmBtn;
